import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { SelectOption, TypographyComponent } from '@hyperkit';
import { HuntContextService } from '../../../../pages/hunt/services/hunt-context.service';
import { CommonModule } from '@angular/common';
import { Enums, Hunt } from '@cyborg-monorepo/hunter/common';
import { ReportTextBlockComponent } from '../report-text-block/report-text-block.component';

@Component({ 
  standalone: true, 
  selector: 'final-report-conclusion',
  imports: [CommonModule, RouterModule, ReportTextBlockComponent, TypographyComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './final-report-conclusion.component.html',
  styleUrls: ['final-report-conclusion.component.scss'],
})
export class FinalReportConclusionComponent  {
  readonly huntContext = inject(HuntContextService);
  public outcomeValues: Enums.OutcomeEnum[] = Object.values(Enums.OutcomeEnum);

  constructor() {
  const route = inject(ActivatedRoute);
  const resolvedHunt = route.snapshot.data['hunt'] as Hunt | null;

    if (resolvedHunt) {
      this.huntContext.state.updateHunt(resolvedHunt);
      this.huntContext.editor.load(resolvedHunt); 
    }
  }

  onSelectionChange(selectedOption: SelectOption | string | number) {
    this.huntContext.editor.updateOutcome(selectedOption as Enums.OutcomeEnum);
  }
}
